import PropTypes from "prop-types";
import { Box, Button } from "@material-ui/core";

const ButtonRow = ({
  handleSubmit,
  handleClose,
  buttonStyle = "",
  disabled = false,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-around"
      style={{ width: "100%" }}
    >
      <Button
        name="runQuery"
        aria-label="run-query-button"
        onClick={handleSubmit}
        className={buttonStyle}
        data-testid="run-query-button"
        variant="contained"
        style={{ margin: "1em", width: "fit-content" }}
        disabled={disabled}
        type="submit"
      >
        Run Query
      </Button>
      <Button
        type="button"
        data-testid="close-button"
        className={buttonStyle}
        style={{ margin: "1em", width: "fit-content" }}
        variant="contained"
        onClick={handleClose}
      >
        Close
      </Button>
    </Box>
  );
};

ButtonRow.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  buttonStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
};

export default ButtonRow;
